import { JsonProperty, Serializable } from 'ts-jackson'
import { Fromable } from '../model'

export enum PAYMENT_TYPE {
  FULL_AMOUNT = 'full-amount',
  INSTALLMENT = 'installment',
  RECURRING = 'recurring',
}

export interface creditQuoteParam {
  creditAmount?: number
  paymentAmount?: number
  isMembership: boolean
}

export interface TransferCreditBody {
  senderId: number
  receiverId: number
  amount: number
}

export interface CreatePaymentBody {
  userId: number
  amount: number
  membershipId?: number
  discount: number
  description: string
  paymentDetails?: {
    paymentMethod: string
    isInstallment: boolean
    installmentPeriod?: number
    installmentRate?: number
    bankFeeId?: number
    /** Serial of the POS machine this sale was rung up on. */
    posId?: string
  }
  taxInvoiceAddress: {
    firstName?: string
    lastName?: string
    companyName?: string
    branch?: string
    /** Thai Tax ID (NATIONAL_ID) or passport number (PASSPORT) */
    taxNo?: string
    idType?: 'NATIONAL_ID' | 'PASSPORT'
    /** Country / nationality — meaningful when idType is PASSPORT */
    country?: string
    addressLine?: string
    provinceId?: number | null
    districtId?: number | null
    subDistrictId?: number | null
    postalCode?: string
  }
}

@Serializable()
export class CreditQuote extends Fromable {
  @JsonProperty()
  creditAmount!: number

  @JsonProperty()
  paymentAmount!: number

  @JsonProperty()
  rate!: number

  @JsonProperty()
  isMembership!: boolean
}

@Serializable()
export class CreditExchange extends Fromable {
  @JsonProperty()
  id!: number

  @JsonProperty()
  minAmount!: number

  @JsonProperty()
  rate!: number

  @JsonProperty()
  isMembership!: boolean
}

@Serializable()
export class Bank extends Fromable {
  @JsonProperty()
  id!: number

  @JsonProperty()
  name!: string

  @JsonProperty()
  feeRate!: number
}

@Serializable()
export class PurchaseCredit extends Fromable {
  @JsonProperty()
  success!: boolean

  @JsonProperty()
  receiptId!: number

  @JsonProperty()
  receiptCode!: string
}

@Serializable()
export class CreditTransactionItem extends Fromable {
  @JsonProperty()
  sku!: string

  @JsonProperty()
  name!: string
}

@Serializable()
export class CreditTransaction extends Fromable {
  @JsonProperty()
  id!: number

  @JsonProperty()
  transactionNo!: string

  @JsonProperty()
  userId!: number

  @JsonProperty()
  type!: string

  @JsonProperty()
  credits!: number

  @JsonProperty()
  description!: string

  @JsonProperty()
  relatedPurchaseId!: number | null

  @JsonProperty()
  actionType!: string

  @JsonProperty()
  actionRefId!: number

  @JsonProperty()
  createdAt!: string

  @JsonProperty({ elementType: CreditTransactionItem })
  items!: CreditTransactionItem[]
}
